"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Missionsbanner() {
  const prefersReducedMotion = useReducedMotion();
  return <section id="missionsbanner" data-nav="light" className="w-full bg-background py-8 md:py-14 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <motion.div initial={prefersReducedMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="relative min-h-[440px] sm:min-h-[500px] md:min-h-[560px] lg:min-h-[620px] w-full overflow-hidden rounded-2xl md:rounded-3xl shadow-lg">
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/ag_world_missions_valley.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/ag_world_missions_valley.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/ag_world_missions_valley.png-wvc-sizes" alt="AG World Missions baptism and community fellowship in a scenic mountain valley" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover object-center" />

          {}
          <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-md md:max-w-lg lg:max-w-xl">
            <motion.div initial={prefersReducedMotion ? {
            opacity: 1
          } : {
            opacity: 0,
            scale: 0.96
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2,
            ease: "easeOut"
          }} className="rounded-2xl md:rounded-3xl bg-background/95 backdrop-blur-md p-6 sm:p-8 md:p-10 shadow-xl border border-border/50">
              <div className="flex flex-col gap-3 sm:gap-4">
                <span className="text-xs font-bold tracking-wider text-muted-foreground uppercase">
                  Misiones Internacionales
                </span>

                <h2 className="text-2xl tracking-tight text-foreground uppercase font-default !font-bold sm:text-3xl md:text-4xl">AMAD</h2>

                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">AMAD se compromete a establecer la iglesia entre todos los pueblos del mundo.</p>

                <div className="pt-2">
                  <Button asChild size="default" className="rounded-full bg-foreground text-background hover:bg-foreground/90 font-semibold px-5 py-2.5 h-auto text-xs sm:text-sm tracking-wide uppercase group shadow-md">
                    <Link to="/MinistriesPage" className="inline-flex items-center gap-1.5">
                      <span>Más Información</span>
                      <ArrowUpRight className="size-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                  </Button>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}